import { DbCheckCargoById } from "../../../data/usecases/check-cargo-by-id";
import { CheckCargoById } from "../../../domain/usecases/check-cargo-by-id";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbCheckCargoById = (): CheckCargoById =>
  new DbCheckCargoById(
    makeApiUrl("/cargo/check-by-id"),
    makeAuthorizeHttpClientDecorator()
  );
